import React from 'react';
import { Link } from 'react-router-dom';
import { Zap, Music, Trophy, Star, PlayCircle, FolderHeart, Headphones } from 'lucide-react';

// Centralized theme color classes
const ICON_COLORS = {
  warning: 'text-yellow-400',
  accent: 'text-purple-400',
  primary: 'text-blue-400',
  success: 'text-green-400',
  info: 'text-pink-400',
  orange: 'text-orange-400',
  eduvibe: 'text-eduvibe-green',
};

// Constants for feature identifiers
export const FEATURES = {
  SUPERCHARGE: 'Supercharge your learning',
  FULL_ACCESS: 'Full access to all content until the beta ends',
  CURRICULUM: 'Curriculum aligned songs',
  GAMIFIED: 'Gamified learning experience',
  POINTS: 'Earn edupoints and badges',
  PLAYLISTS: 'Playlists to organise your content',
  PODCASTS: 'Engaging podcasts for tricky concepts',
};

// Decoupled feature-icon mapping
export const defaultFeatureIconMap = {
  [FEATURES.SUPERCHARGE]: <Zap className={ICON_COLORS.warning} />,
  [FEATURES.FULL_ACCESS]: <Music className={ICON_COLORS.accent} />,
  [FEATURES.CURRICULUM]: <PlayCircle className={ICON_COLORS.primary} />,
  [FEATURES.GAMIFIED]: <Trophy className={ICON_COLORS.orange} />,
  [FEATURES.POINTS]: <Star className={ICON_COLORS.warning} />,
  [FEATURES.PLAYLISTS]: <FolderHeart className={ICON_COLORS.info} />,
  [FEATURES.PODCASTS]: <Headphones className={ICON_COLORS.success} />,
};

const PricingPlanCard = ({ name, price, features, cta, onSelectPlan, featureIconMap = defaultFeatureIconMap }) => {
  return (
    <div className="bg-eduvibe-blue bg-opacity-50 p-8 rounded-xl backdrop-filter backdrop-blur-lg text-center transform hover:scale-105 transition duration-300 border border-eduvibe-green shadow-lg hover:shadow-eduvibe-green">
      <div className="text-3xl font-bold text-eduvibe-green mb-6">{name}</div>
      <div className="text-4xl font-bold mb-8 text-white">{price}</div>
      <ul className="space-y-4 mb-8">
        {features.map((feature, index) => {
          const icon = featureIconMap[feature];
          if (!icon) {
            // eslint-disable-next-line no-console
            console.warn(`No icon mapping found for feature: ${feature}`);
          }
          return (
            <li key={index} className="flex items-center space-x-3 text-left">
              <span className="flex-shrink-0">{icon || <Star className={ICON_COLORS.eduvibe} />}</span>
              <span>{feature}</span>
            </li>
          );
        })}
      </ul>
      <button
        onClick={onSelectPlan}
        className="w-full bg-eduvibe-green text-eduvibe-dark px-8 py-3 rounded-full text-lg font-bold hover:bg-opacity-90 transition duration-300 transform hover:scale-105 shadow-lg hover:shadow-eduvibe-green"
      >
        {cta.text}
      </button>
    </div>
  );
};

export default PricingPlanCard;
